import { render, staticRenderFns } from "./PageHeader.vue?vue&type=template&id=4f8c5081"
var script = {}
import style0 from "./PageHeader.vue?vue&type=style&index=0&id=4f8c5081&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports